var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49727 9.21318C1.36108 8.99754 1.29299 8.88972 1.25487 8.72342C1.22624 8.5985 1.22624 8.4015 1.25487 8.27658C1.29299 8.11028 1.36108 8.00246 1.49727 7.78682C2.62268 6.00484 5.97255 1.5 11.0776 1.5C16.1826 1.5 19.5324 6.00484 20.6578 7.78682C20.794 8.00246 20.8621 8.11028 20.9002 8.27658C20.9289 8.4015 20.9289 8.5985 20.9002 8.72342C20.8621 8.88972 20.794 8.99754 20.6578 9.21318C19.5324 10.9952 16.1826 15.5 11.0776 15.5C5.97255 15.5 2.62268 10.9952 1.49727 9.21318Z",
    stroke: "#7BA4D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0776 11.5C12.7344 11.5 14.0776 10.1569 14.0776 8.5C14.0776 6.84315 12.7344 5.5 11.0776 5.5C9.4207 5.5 8.07755 6.84315 8.07755 8.5C8.07755 10.1569 9.4207 11.5 11.0776 11.5Z",
    stroke: "#7BA4D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicon);
export default __webpack_public_path__ + "static/media/eye.icon.39f7241a8af55851a45d6c92e0937932.svg";
export { ForwardRef as ReactComponent };